import gql from 'graphql-tag';

export const GET_ADMIN_AFFILIATES = gql`
	query GetAdminAffiliates($query: JSON!) {
		users(query: $query) {
			id
			name
			email
			phoneNumber
			image
			role
			regions {
				id
				name
			}
		}
	}
`;
